import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { ConversationResource } from './Conversation';
import { EmployerProfileResource } from './EmployerProfile';
import { UserProfileResource } from 'util/resources/UserProfile';
import { EmployerResource } from 'util/resources/Employer';
import { Base } from 'active-resource';

/**
 * Relationship classes
 */
export class MessageAttributes {
  createdAt: string = null;
  data: string = null;
  id: number = null;
  profileType: string = null;
  readAt: string = null;
  updatedAt: string = null;
  messageType: string = null;
  metadata: object = null;
  interviewScheduledAt: string = null;
  interviewScheduled: boolean = null;
  deletedAt: string = null;
}

export class MessageBelongsTo {
  conversation: () => ConversationResource = () => new ConversationResource();
  employerProfile: () => EmployerProfileResource = () => new EmployerProfileResource();
}

export class MessageBelongsToPolymorphic {
  profile: () => UserProfileResource | EmployerResource = () => null;
}

export class MessageHasOne {}
export class MessageHasMany {}

/**
 * Utility interfaces
 */
export interface MessageMethods {}

export interface MessageInterface
  extends MessageAttributes,
    MessageBelongsTo,
    MessageBelongsToPolymorphic,
    MessageType {}

type MessageType = GConstructor<MessageInterface>;

export interface MessageResource
  extends Base<MessageAttributes>,
    MessageInterface,
    MessageMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<MessageAttributes>({
    queryName: 'messages',
    className: 'Message',
    AttributesClass: MessageAttributes,
    BelongsToClasses: [
      {
        Klass: MessageBelongsTo,
      },
      {
        Klass: MessageBelongsToPolymorphic,
        options: { polymorphic: true },
      },
    ],
  });

export const MessageResourceClass = <TBase extends MessageType>(BaseConstructor: TBase): TBase =>
  class extends BaseConstructor implements MessageMethods {};

export class MessageResource extends ClassExtender<MessageInterface>(
  BaseClass,
  MessageResourceClass,
) {}

/**
 * Resource instance
 */
export const Message = APILibrary.createResource<MessageResource>(MessageResource);
